import { GlobalAuthority } from '@app/shared/models/global-authority';
import { User } from '@app/shared/models/user.interface';

export interface IGlobalAuthorityRequest {
  id: number;
  userId: number;
  globalAuthority: GlobalAuthority;
  requestTimestamp: Date;
  emailSent: Date;
  message: string;
  managingCompanyName: string;
  managingCompanyId?: number | null;
  projectName: string;
  status: Status;
  user: User;
  authSource: string;
}

export class GlobalAuthorityRequest implements IGlobalAuthorityRequest {
  public id: number;
  public userId: number;
  public globalAuthority: GlobalAuthority;
  public requestTimestamp: Date;
  public emailSent: Date;
  public message: string;
  public managingCompanyName: string;
  public managingCompanyId?: number | null;
  public projectName: string;
  public status: Status;
  public user: User;
  public authSource: string;

  constructor(globalAuthorityRequest: IGlobalAuthorityRequest) {
    this.id = globalAuthorityRequest.id;
    this.userId = globalAuthorityRequest.userId;
    this.globalAuthority = globalAuthorityRequest.globalAuthority;
    this.requestTimestamp = globalAuthorityRequest.requestTimestamp;
    this.emailSent = globalAuthorityRequest.emailSent;
    this.message = globalAuthorityRequest.message;
    this.managingCompanyName = globalAuthorityRequest.managingCompanyName;
    this.managingCompanyId = globalAuthorityRequest.managingCompanyId;
    this.projectName = globalAuthorityRequest.projectName;
    this.status = globalAuthorityRequest.status;
    this.user = globalAuthorityRequest.user;
    this.authSource = globalAuthorityRequest.authSource;
  }
}

export enum Status {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED'
}
